import React, { useRef, useState } from "react";
import { Container } from "reactstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Protection from "./Protection";
import CashValue from "./CashValue";
import { useTranslation } from "../../Hooks/useTranslation";

const ProtectionPlusPolicyTabDesktop = () => {
  const translations = useTranslation();
  const sliderRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);

  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    adaptiveHeight: true,
    beforeChange: (_, next) => setActiveTab(next),
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
    sliderRef.current?.slickGoTo(index);
  };

  return (
    <section className="section py-16 lg:py-0">
      <div className="relative">
        {/* Header */}
        <div className="container">
          <div className="universal-header-tabs lg:pt-28 max-w-[460px]">
          <div className="text-sm text-gray-600 mb-1 learnmoreacc hidden lg:block">
            {translations.universeProduct_subtitle}
          </div>

          <h2
            className="lg:text-[2.5rem] lg:leading-[2.8rem] text-[24px] leading-[28px] mb-6 extra-title-heading"
            dangerouslySetInnerHTML={{
              __html: translations.universeProduct_heading,
            }}
          />

          {/* Tabs */}
          <div className="flex gap-2 bg-white rounded-full max-w-[260px] universal-tabs-vs">
            <button
              onClick={() => handleTabClick(0)}
              className={`flex-1 py-2 rounded-full text-sm extra-btn-font ${
                activeTab === 0 ? "active-button-state" : ""
              }`}
            >
              {translations.universeProtection_tab}
            </button>

            <button
              onClick={() => handleTabClick(1)}
              className={`flex-1 py-2 rounded-full text-sm extra-btn-font ${
                activeTab === 1 ? "active-button-state" : ""
              }`}
            >
              {translations.universeCashValue_tab}
            </button>
          </div>
        </div>
        </div>

        {/* Slick Slider */}
        <div className="mt-10 protectionTabs">
          <Slider ref={sliderRef} {...settings}  >
            <div className="slick-slide-wrapper">
              <Protection />
            </div>
            <div className="slick-slide-wrapper">
              <CashValue />
            </div>
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default ProtectionPlusPolicyTabDesktop;
